enum ImportFormFieldNames {
  FileUpload = 'fileUpload',
  FileUploadErrors = 'fileUploadErrors',
  IgnoreErrors = 'ignoreErrors',
  Type = 'type',
  Title = 'title',
}

export default ImportFormFieldNames;
